import axios from 'axios';
import Router from 'next/router'
import Cookies from 'js-cookie';

const https = require('https');

const getToken = () => {
    const auth = Cookies.get('pingi_auth_token');

    if (auth && auth.length > 0) {
        return auth;
    }
    return '';
};

const getError = (error) => {
    if (error?.message === 'Network Error') {
        return {
            success: false,
            code: null,
            networkError: true,
            error: 'لطفا از متصل بودن اینترنت خود مطمئن شوید.'
        };
    } else if (error?.response) {
        let data = error.response?.data;
        let errorData = (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined')
            ? data.errors ?? data.detail ?? data.error_description ?? (typeof data === 'object' ? {...data} : {message: 'خطایی رخ داده است'})
            : {message: 'خطایی رخ داده است'};

        return {
            success: false,
            code: error.response.status,
            error: errorData,
            attention: data?.attention
        };
    }

    return {
        success: false,
        code: null,
        networkError: true,
        error: 'خطا در ارتباط با سرور مقصد.'
    };
};

const configResponse = (response) => {
    if (typeof response.data.status === "undefined") {
        let tmp;
        if (typeof response.data.results === "undefined") {
            tmp = {
                success: true,
                results: response.data
            }
        } else {
            tmp = {
                ...response.data,
                success: true
            }
        }
        response.data = tmp;

        return response;
    } else
        return response;
};

export const getApiService = (reqUrl, reqData, token = null, signal) => {
    const _ = require('lodash');
    token = token ?? getToken();

    const config = {
        url: `${reqUrl}`,
        method: 'GET',
        httpsAgent: new https.Agent({
            rejectUnauthorized: false
        }),
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'fa',
        },
        signal
    };

    if (token)
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        }

    if (reqData) {
        if (Array.isArray(reqData) || _.isObject(reqData))
            config.params = reqData;
        else
            config.url += (_.startsWith(reqData, '?')) ? reqData : '?' + reqData;
    }

    return new Promise(resolve => {
        axios(config)
            .then(res => {
                resolve(configResponse(res));
            })
            .catch(error => {
                if (error.response && [401, 403].indexOf(error.response.status) !== -1) {
                    Router.push('/logout?auth_error=1');
                }
                resolve(getError(error));
            });
    });
};

export const postApiService = (reqUrl, reqData, reqHasFiles, baseUrl = null, token = null, percentageHOC = null, timeout = 30000) => {
    token = token ?? getToken();
    if (percentageHOC)
        percentageHOC(0);

    const config = {
        url: reqUrl,
        method: 'POST',
        timeout: timeout,
        httpsAgent: new https.Agent({
            rejectUnauthorized: false
        }),
        headers: {
            'Content-Type': reqHasFiles ? 'multipart/form-data' : 'application/json',
            'Accept-Language': 'fa',
        },
        onUploadProgress: function (progressEvent) {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);

            if (percentageHOC)
                percentageHOC(percentCompleted)
        }
    };

    if (token)
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        }

    if (reqHasFiles) {
        const formData = new FormData();
        if (reqData) {
            Object.entries(reqData).map(([key, val]) => {
                if (Array.isArray(val)) {
                    val.map(item => {
                        return formData.append(key, item);
                    });
                } else {
                    if (val?.name)
                        return formData.append(key, val, val.name);

                    return formData.append(key, val);
                }
                return null;
            });
        }
        config.data = formData;
    } else if (reqData && !reqHasFiles) config.data = reqData;

    return new Promise(resolve => {
        axios(config)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                // Library bug
                if (error.response && [201].indexOf(error.response.status) !== -1) {
                    resolve(error);
                }

                if (error.response && [401, 403].indexOf(error.response.status) !== -1) {
                    Router.push('/logout?auth_error=1');
                }
                resolve(getError(error));
            });
    });
};

export const putApiService = (reqUrl, reqData, reqHasFiles, token = null) => {
    token = token ?? getToken();
    const config = {
        url: `${reqUrl}`,
        method: 'PUT',
        httpsAgent: new https.Agent({
            rejectUnauthorized: false
        }),
        headers: {
            'Content-Type': reqHasFiles ? 'multipart/form-data' : 'application/json',
            'Accept-Language': 'fa',
        },
    };

    if (token)
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        }

    if (reqHasFiles) {
        const formData = new FormData();
        if (reqData) {
            Object.entries(reqData).map(([key, val]) => {
                if (Array.isArray(val)) {
                    val.map(item => {
                        return formData.append(key, item);
                    });
                } else {
                    return formData.append(key, val);
                }
                return null;
            });
        }
        config.data = formData;
    } else if (reqData && !reqHasFiles) config.data = reqData;

    return new Promise(resolve => {
        axios(config)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                if (error.response && [401, 403].indexOf(error.response.status) !== -1) {
                    Router.push('/logout?auth_error=1');
                }
                resolve(getError(error));
            });
    });
};

export const patchApiService = (reqUrl, reqData, reqHasFiles, token = null) => {
    token = token ?? getToken();
    const config = {
        url: `${reqUrl}`,
        method: 'PATCH',
        httpsAgent: new https.Agent({
            rejectUnauthorized: false
        }),
        headers: {
            'Content-Type': reqHasFiles ? 'multipart/form-data' : 'application/json',
            'Accept-Language': 'fa',
        },
    };

    if (token)
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        }

    if (reqHasFiles) {
        const formData = new FormData();
        if (reqData) {
            Object.entries(reqData).map(([key, val]) => {
                if (Array.isArray(val)) {
                    val.map(item => {
                        return formData.append(key, item);
                    });
                } else {
                    return formData.append(key, val);
                }
                return null;
            });
        }
        config.data = formData;
    } else if (reqData && !reqHasFiles) config.data = reqData;

    return new Promise(resolve => {
        axios(config)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                if (error.response && [401, 403].indexOf(error.response.status) !== -1) {
                    Router.push('/logout?auth_error=1');
                }
                resolve(getError(error));
            });
    });
};

export const deleteApiService = (reqUrl, token = null) => {
    token = token ?? getToken();
    const config = {
        url: `${reqUrl}`,
        method: 'DELETE',
        httpsAgent: new https.Agent({
            rejectUnauthorized: false
        }),
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'fa',
        },
    };

    if (token)
        config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
        }

    return new Promise(resolve => {
        axios(config)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                if (error.response && [401, 403].indexOf(error.response.status) !== -1) {
                    Router.push('/logout?auth_error=1');
                }
                resolve(getError(error));
            });
    });
};

export default {
    getApiService,
    postApiService,
    putApiService,
    deleteApiService,
};
